import { Button } from "~/react/ui/button"

export const EmptyState = ({ clearFilters }: { clearFilters?: () => void }) => {
  return (
    <div className="d-flex flex-column gap-2 justify-content-center align-items-center mt-16" data-testid="empty-state">
      <span className="far fa-info-circle text-hint" aria-hidden="true"></span>
      <span className="text-body-secondary">
        {i18n.t("js.search.empty_state.text")}
      </span>

      {clearFilters && (
        <Button
          variant="linkGrey"
          className="fw-medium"
          data-testid="clear-filters-btn"
          onClick={clearFilters}
        >
          {i18n.t("js.search.empty_state.clear_filters")}
        </Button>
      )}
    </div>
  )
}
